import React, { useState } from "react";
import "./TopReviews.css";
import Review_Card from "./review_card/Review_Card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import Common_Title from "../../../components/common_components/common_title/Common_Title";

const TopReviews = ({ all_review, product }) => {
  const top_reviews = [
    {
      name: "John Doe",
      image: "/assets/images/products/img1.png",
      review:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
      date: "05/11/2024",
    },

    {
      name: "John Doe",
      image: "/assets/images/products/img1.png",
      review:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
      date: "05/11/2024",
    },

    {
      name: "John Doe",
      image: "/assets/images/products/img1.png",
      review:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
      date: "05/11/2024",
    },
    {
      name: "John Doe",
      image: "/assets/images/products/img1.png",
      review:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
      date: "05/11/2024",
    },

    {
      name: "John Doe",
      image: "/assets/images/products/img1.png",
      review:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
      date: "05/11/2024",
    },

    {
      name: "John Doe",
      image: "/assets/images/products/img1.png",
      review:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
      date: "05/11/2024",
    },
  ];
  // console.log(all_review, "all_reviews");

  const [showAll, setShowAll] = useState(false);

  // const displayedReviews = showAll ? all_review : all_review.data?.slice(0, 3);

  // console.log(all_review, "all_review all_review all_review");

  return (
    <div className="TopReviews">
      <div className="container">
        <Common_Title title={"Top Reviews"} />
        {/* {showAll ? all_review.length : all_review.length} */}
        <div className="review_card_holder">
          {all_review?.data?.map((review, index) => (
            <Review_Card key={index} review={review} product={product} />
          ))}
        </div>

        {/* {all_review?.length > 3 && (<div className='show_all_text' onClick={() => setShowAll(!showAll)}>
                <p>
                    {showAll ? "View Less" : "View All"}{" "}
                    <FontAwesomeIcon icon={faAngleRight} className='righticon' />
                </p>
            </div>)} */}
      </div>
    </div>
  );
};

export default TopReviews;
